<template>
  <section class="api-banner">
    <div class="banner-content">
      <div
        :style="{
          'background-image': `url(${getFeUrl('/youyan-platform/api-intro/banner/keyboard.png')})`,
        }"
        class="keyboard api-banner__left"
      />
      <div class="mid-content-flex"></div>
      <div
        :style="{
          'background-image': `url(${getFeUrl('/youyan-platform/api-intro/banner/keyboard.png')})`,
        }"
        class="keyboard api-banner__right"
      ></div>
    </div>

    <h1 class="api-banner__title">
      <p>接入有言 API</p>
      <p>构建属于你的 AI 视频生成引擎</p>
    </h1>
    <p class="api-banner__desc">
      有言提供高效易用的视频生成 API，支持将文本、PPT
      转化为高质量数字人视频，快速搭建专业视频生产能力。
    </p>
    <div class="api-banner__operation">
      <ArrowBtn variant="black-large" text="立即咨询" @click="$emit('consultClick')" />
    </div>
    <div class="api-banner__grid">
      <AdvantageCard v-for="card in list" v-bind="card" />
    </div>
  </section>
</template>

<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import { getFeUrl } from '@/utils/url';
import AdvantageCard from '~/design/components/advantage-card/index.vue';

const list = [
  {
    title: '文本生成视频 API',
    desc: '输入文本，调用数字人 API，自动生成带表情、动作与语音的 AI 数字人视频。一键将文稿批量转化为视频，极致降本增效，重塑内容生产力。',
    link: '/help-center/45-205.html',
    linkText: '查看接入文档',
  },
  {
    title: 'PPT 生成视频 API',
    desc: '一键接入，即可将 PPT 幻灯片智能转化为AI 数字人讲解视频。自动匹配镜头、动作与场景，让静态演示秒变生动，高效激活存量知识资产。',
    link: '/help-center/45-205.html',
    linkText: '查看接入文档',
  },
  {
    title: '集成登录 API',
    desc: '为合作伙伴提供无缝账号对接。您的用户可直接登录，调用全套 AI 视频生成能力，快速将高质量数字人服务嵌入自身业务，提升竞争力。',
    link: '/help-center/45-205.html',
    linkText: '查看接入文档',
  },
];
</script>

<style lang="scss" scoped>
.api-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 100px 0 0;
}

.banner-content {
  pointer-events: none;
  position: absolute;
  top: 100px;
  width: 100vw;
  display: flex;
  .mid-content-flex {
    flex: 1;
    min-width: 968px;
  }
}

.keyboard {
  display: block;
  width: 457px;
  height: 528px;
  background-size: 960px 528px;

  &.api-banner__right {
    //
  }

  &.api-banner__left {
    transform: scaleX(-1);
  }
}

.api-banner__title {
  color: var(--x-text-1);
  text-align: center;
  font-family: 'dt-font';
  font-size: 72px;
  line-height: 86px;
  font-weight: 400;
  letter-spacing: -1px;
  margin: 0;
  h1,
  p {
    margin: 0;
  }
  margin-bottom: 24px;
}
.api-banner__desc {
  color: var(--x-text-5);
  text-align: center;
  font-size: 16px;
  letter-spacing: -0.1px;
  font-weight: 400;
  line-height: 28px; /* 175% */
  margin: 0;
  margin-bottom: 40px;
}
.api-banner__operation {
  display: flex;
  align-items: center;
  justify-self: center;
  gap: 32px;
  .doc-link {
    text-decoration: none;
  }
}
.api-banner__grid {
  width: clamp(1200px, 1200px + (100vw - 1600px) * 0.75, 1440px);
  margin-top: 100px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}
</style>
